import axiosInstance from './AxiosInstance';

class ApplicationLocks {
    constructor() {
        this.endpoint = "/api/applications/"
    }

    async lock(id) {
        return {success:false}
        try {
            const response = await axiosInstance.get(`${this.endpoint}${id}/lock`);

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async unlock(id) {
        return {success:true}
        try {
            const response = await axiosInstance.get(`${this.endpoint}${id}/unlock`);

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

        async closeApplication(id) {
        try {
            const response = await axiosInstance.put(`${this.endpoint}${id}/close`);

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

}

const applicationLocks = new ApplicationLocks();

export { applicationLocks };